export const DEFAULT_STEPS_NUM = 20
